
import { Profile } from "@/types/profile";
import { supabase } from "@/integrations/supabase/client";

export const isProfileData = (data: any): boolean => {
  return (
    typeof data === 'object' && 
    data !== null &&
    typeof data.id === 'string' && 
    (data.role === 'student' || data.role === 'creator')
  );
};

/**
 * Get the count of enrollments for a course
 */
export async function getCourseEnrollmentCount(courseId: string): Promise<number> {
  try {
    const { count, error } = await supabase
      .from('enrollments')
      .select('id', { count: 'exact', head: false })
      .eq('course_id', courseId)
      .limit(1);
    
    if (error) throw error;
    return count || 0;
  } catch (error) {
    console.error("Error getting course enrollment count:", error);
    return 0;
  }
}

/**
 * Get the count of reviews for a course
 */
export async function getCourseReviewCount(courseId: string): Promise<number> {
  try {
    const { count, error } = await supabase
      .from('course_reviews')
      .select('id', { count: 'exact', head: false })
      .eq('course_id', courseId)
      .eq('is_public', true)
      .limit(1);
    
    if (error) throw error;
    return count || 0;
  } catch (error) {
    console.error("Error getting course review count:", error);
    return 0;
  }
}
